import { Box } from "@mui/material";
import BloqueVista from "../../components/public/BloqueVista";

/**
 * "Inicio" dentro de la app (`/app/inicio`): el mismo bloque que la portada del
 * sitio público. Al entrar a la app se pierde el header público, y con él el
 * acceso a esta información; aquí vuelve, con la barra lateral a mano.
 *
 * El layout ya pone el respiro y el fondo: esta página solo acota el ancho de
 * lectura.
 */
export default function Inicio() {
  return (
    <Box sx={{ maxWidth: 820, mx: "auto" }}>
      <BloqueVista clave="home" editable />
    </Box>
  );
}
